import {  useContext, useEffect, useState } from 'react';
import ActionButton from '../../../ui/ActionButton';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import { Search } from "../../../filtering";
import { pimsHouseDownloadList, TableColumn, TableSettings } from '../../../tableSettings';
import AbstractListView, {
  DataFetchResult,ExportRowRenderer,ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../AbstractListView";
import JobListViewContext from '../JobListViewContext';
import {
  DateRenderer,DateTimeRenderer,FloatRenderer,IndicatorRenderer,NullableCheckboxIconRenderer,
  TextAlignLeftRenderer,TextAlignRightRenderer,TextRenderer,
} from '../../../uiControls/SmartTableRenderers';
import { JobNames } from '../../../framework.core/JobNames';
import IfmsModal from "../../../ui/IfmsModal";
import ListViewShortcutMenu from '../ListViewShortcutMenu';
import * as XCol from '../../../framework.core/XExportColumn';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import PrimaryButton from '../../../ui/PrimaryButton';
import { PimsVanningListItem } from '../../../fms.data/models/PimsVanningListItem';
import ApplicationContext from '../../../ApplicationContext';
import { NavigationType, openNewPage } from '../../../util/navigationHelpers';
import { useHistory } from 'react-router';

function formatData(data: Array<PimsVanningListItem>) {
  return data;
}

function useSelectedDownloadItem() {
  const jobListContext = useContext(JobListViewContext);

  const selectedElement = jobListContext.selectedElement as PimsVanningListItem | null;

  function view() {
    jobListContext.showPopupRow();
  }

  return { selectedElement, view };
}

function DownloadListCommands({ context }: {
  context: JobNames.OIHMyPims | JobNames.OIHPims | JobNames.OEHMyPims | JobNames.OEHPims |
  JobNames.AIHMyPims | JobNames.AIHPims | JobNames.AEHMyPims | JobNames.AEHPims
}) {
  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  
  const { selectedElement } = useSelectedDownloadItem();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const [view, showView] = useState(false);
  const history = useHistory();
  
  let title = 'Download HBL';
  let buttonCatpion = 'Download to OI';

  switch (context) {
    case JobNames.OIHPims:
    case JobNames.OEHPims:
      title = 'Download HBL';
      break;
    case JobNames.AIHPims:
    case JobNames.AEHPims:
      title = 'Download HAWB';
      break;
  }

  switch (context) {
    case JobNames.OIHPims:
      buttonCatpion = 'Download to OI';
      break;
    case JobNames.OEHPims:
      buttonCatpion = 'Download to OE';
      break;
    case JobNames.AIHPims:
      buttonCatpion = 'Download to AI';
      break;
    case JobNames.AEHPims:
      buttonCatpion = 'Download to AE';
      break;
  }

  async function block(isBlock: boolean) {
    const doBlock = await showGlobalYesNoDialog(<p style={{ fontWeight: 'bold', fontSize: '13px' }}>Are you sure you want to {(isBlock ? "Block" : "Cancel block")}?</p>,false, 0, true)

    if (doBlock) {
      const id = selectedElement?.id;

      await appContext.api.block(context, id, isBlock);

      jobListContext.reloadData();
    }
  }

  function dismissView() {
    showView(false);
    jobListContext.dismissPopupRow();
  }

  async function viewDownloadView() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;

    const viewUrl = `/oceanImport/download/${context}/${id}`;

    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  return (
    <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
      <div className="ifms-common-no-vertical-separator">
        <PrimaryButton
          size="regular"
          disabled={!selectedElement}
          onClick={() => showView(true)}
        >
          View
        </PrimaryButton>&nbsp;

        <PrimaryButton
          size="regular"
          disabled={!selectedElement}
          onClick={() => block(true)}
        >
          Block
        </PrimaryButton>&nbsp;

        <PrimaryButton
          size="regular"
          disabled={!selectedElement}
          onClick={() => block(false)}
        >
          Cancel Block
        </PrimaryButton>
      </div>
      <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
        <PrimaryButton
          size="regular"
          disabled={!selectedElement}
          onClick={() => viewDownloadView()}
        >
          {buttonCatpion}
        </PrimaryButton>&nbsp;
        <ActionButton
          type="primary"
          variant="plain"
          items={[
            { label: `${title} (All) List` },
            { label: `${title} (Downloaded) List` },
            { label: `${title} (Not Downloaded) List` },
          ]}
        >
          More Menu
        </ActionButton>
      </div>
      <IfmsModal isBlueHeader onCancel={dismissView} draggable isOpen={view || !!jobListContext.viewPopupRow} title="View Voyage" width="760px">
        {/* <ViewVoyage onPopupClose={dismissView} selectedElementId={selectedElement?.id ?? ''} /> */}
      </IfmsModal>
    </div>
  );
}

function DownloadListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function HouseDownloadListViewExtras() {
  useFunctionKeys({ onFunction: onFunctionKey });

  const jobListContext = useContext(JobListViewContext);

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
    if (!unprocessedFkey) {
      return;
    }

    doProcessFkey();
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F11', 'F8'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.OiPims}
      jobId={(jobListContext.selectedElement as PimsVanningListItem | null)?.id ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
    />
  );
}

/**
 * Concrete implementation for Download List screen
 *
 * @class HouseDownloadListView
 * @extends {AbstractListView}
 */
class HouseDownloadListView extends AbstractListView {
  private jobName: JobNames.OIHMyPims | JobNames.OIHPims | JobNames.OEHMyPims | JobNames.OEHPims |
    JobNames.AIHMyPims | JobNames.AIHPims | JobNames.AEHMyPims | JobNames.AEHPims;

  constructor(jobName: JobNames.OIHMyPims | JobNames.OIHPims | JobNames.OEHMyPims | JobNames.OEHPims |
    JobNames.AIHMyPims | JobNames.AIHPims | JobNames.AEHMyPims | JobNames.AEHPims) {
    super();
    this.jobName = jobName;
  }

  async fetchAndFormatData(api: any, search: Search): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(this.jobName,
      'PimsVanningListItem',
      PimsVanningListItem.calculateSearchParameters(search, PimsVanningListItem.MapSearchFields),
      1,
      search.pageSize);

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return { data: [], totalCount: 0 };
    }

    return { data: formatData(apiResult.entities), totalCount: apiResult.totalCount };
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
    ];
  }

  getRowRenderers(): ListRowRenderer[] {
    return PimsVanningListItem.getExportCollection(this.jobName).map(x => {
      const colRenderer: ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if (x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if (x.align === XCol.XAlignType.Right) colRenderer.Cell = TextAlignRightRenderer;
      if (x.dataIndex === "status") colRenderer.Cell = IndicatorRenderer;
      else if (x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if (x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if (x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if (x.type === XCol.XCellType.Double) {
        if (x.dataIndex === 'id')
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} useComma={false} decimals={0} />;
        else
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={2} />;
      }
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});    
    colRenderer.push({ accessor: 'id', changedValue: (value: any) => { return value['id'] } });
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'id',
      orderByAscending: false,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings = pimsHouseDownloadList;
    const cols = PimsVanningListItem.getExportCollection(this.jobName);
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type };
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <DownloadListCommands context={this.jobName} />
    );
  }

  renderBeforeConfigureButton() {
    return (
      <DownloadListToolbar />
    );
  }

  renderExtras() {
    return <HouseDownloadListViewExtras />
  }

  getViewUrlFor() {
    return '';
  }

  getListViewTitle() {
    switch (this.jobName) {
      case JobNames.OIHPims:
      case JobNames.OEHPims:
        return 'Download HBL List';
      case JobNames.AIHPims:
      case JobNames.AEHPims:
        return 'Download HAWB List';
      case JobNames.OIHMyPims:
      case JobNames.OEHMyPims:
        return 'Download MY HBL List';
      case JobNames.AIHMyPims:
      case JobNames.AEHMyPims:
        return 'Download MY HAWB List';
    }
  };
};

export default HouseDownloadListView;